import React, { useState, Suspense, lazy } from "react";
import { Container, Grid } from "@mui/material";

import { RequirementListPagination } from "./components/RequirementListPagination";
import { RequirementListHeader } from "./components/RequirementListHeader";
import RequirementListTable from "./components/RequirementListTable";
import { RequirementLegend } from "./components/RequirementLegend";
import { FilterContextProvider } from "./components/SearchFilter/FilterContext";

import { TableGridItem } from "./style";
import { fetchRequirements } from "../../usecases/requirement/requirementListUseCase";
import { useDispatch } from "react-redux";
const RequirementsListFilter = lazy(() => import("./components/SearchFilter"));

export function RequirementList () {
  const [filterOpen, setFilterOpen] = useState(false);
  const dispatch = useDispatch();
  
  const handleFilter = () => {
    setFilterOpen(!filterOpen);
  };

  const handleApplyFilter = (options: any) => {
    fetchRequirements(`?${options}`, 0, 10)(dispatch);
    setFilterOpen(false);
  };

  return (
    <>
      <Container maxWidth="xl">
        <Grid container>
          <RequirementListHeader onOpenFilter={handleFilter} />
        </Grid>
        <Grid container sx={{ display: "flex" }}>
          <TableGridItem item sm={12}>
            <RequirementLegend />
            <RequirementListTable />
          </TableGridItem>
        </Grid>
        {filterOpen &&
          <Suspense fallback={<div>Loading...</div>}>
            <RequirementsListFilter isOpen={filterOpen} onApply={handleApplyFilter} onClose={handleFilter} />
          </Suspense>
        }
      </Container>
      <FilterContextProvider>
        <RequirementListPagination />
      </FilterContextProvider>
    </>
  );
}
